import React from 'react';
import { Typography, Button, Container, Paper } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 5, mt: 5, textAlign: 'center' }}>
        <Typography variant="h1" component="h1" gutterBottom sx={{ fontSize: '8rem', fontWeight: 'bold', color: 'primary.main' }}>
          404
        </Typography>

        <Typography variant="h4" gutterBottom>
          Strona nie znaleziona
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          Przepraszamy, ale strona której szukasz nie istnieje lub została przeniesiona.
        </Typography>

        <Button variant="contained" component={Link} to="/" size="large">
          Wróć do strony głównej
        </Button>
      </Paper>
    </Container>
  );
};

export default NotFoundPage;
